import React from 'react'
import { Row } from 'antd'
import { IconHelper } from '../../helpers'

const CameraClose = () => {
    const { IconNoPicture } = IconHelper
    return (
        <Row className="no-camera">        
            <IconNoPicture />
        </Row>
    )
}

export default CameraClose